<template>
  <div class="advantage">
    <div class="container">
      <h4>{{ $t('home.advantage.title') }}</h4>
      <ul class="advantage-list">
        <li v-for="(advantage, index) in advantageList" :key="advantage.iconUrl"
          :class="['advantage-item', index === 1 ? 'active' : '']">
          <img :src="advantage.iconUrl" alt="" srcset="" />
          <span>{{ advantage.desc }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'advantage',

  data() {
    return {
    }
  },

  computed: {
    reasonList: () =>
      Array(4)
        .fill('')
        .map(() => ({
          title: 'Global Operation',
          content:
            'Global Operations is a first-person tactical shooter video game developed ased in March 2002, following …',
        })),
    advantageList: function() {
      return [
        { iconUrl: require('../../assets/image/home/advantage_icon_activity.svg'), desc: this.$t('home.advantage.advantage1') },
        { iconUrl: require('../../assets/image/home/advantage_icon_security.svg'), desc: this.$t('home.advantage.advantage2') },
        { iconUrl: require('../../assets/image/home/advantage_icon_latency.svg'), desc: this.$t('home.advantage.advantage3') },
        { iconUrl: require('../../assets/image/home/advantage_icon_available.svg'), desc: this.$t('home.advantage.advantage4') },
        { iconUrl: require('../../assets/image/home/advantage_icon_order.svg'), desc: this.$t('home.advantage.advantage5') },
        { iconUrl: require('../../assets/image/home/advantage_icon_service.svg'), desc: this.$t('home.advantage.advantage6') }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.advantage {
  background: #F5F6F8;

  .container {
    padding: 80px 0 100px;
    text-align: center;

    h4 {
      width: 100%;
      height: 43px;
      font-size: 36px;
      font-family: Barlow-ExtraBold, Barlow;
      font-weight: 800;
      color: #000000;
      line-height: 43px;
    }

    h4 {
      color: #000;
      font-size: 34px;
    }
  }
}

.advantage-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 50px;
  row-gap: 50px;
  margin-top: 58px;

  .advantage-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 38px;
    width: 340px;
    min-height: 228px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 5px 30px 0px rgba(73, 86, 117, 0.05);
    transition: all .5s;

    span {
      font-size: 24px;
      line-height: 34px;
      font-family: PingFang SC;
      color: #000;
      margin-top: 20px;
    }

    small {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, .6);
      line-height: 20px;
      margin-top: 10px;
    }

    .btn-group {
      display: flex;

      .btn {
        margin-right: 6px;
        margin-left: 6px;
        text-wrap: nowrap;
      }
    }

    .btn {
      margin-top: 40px;
    }
  }

  .active {
    background: #0D73D6;
    box-shadow: 0px 5px 30px 0px rgba(73, 86, 117, 0.4);

    span {
      color: #fff;
    }

    small {
      color: rgba(255, 255, 255, .6);
    }

    .btn-primary {
      color: #0D73D6;
      background-color: #fff;
    }
  }
}

.slider {
  background-size: cover;

  //@include bg-image('../../assets/image/home/adv-slider-bg');
  .title {
    text-align: center;
    margin-top: 96px;
    font-size: 40px;
    font-weight: 600;
    @include title-bold();
  }

  .reason-list {
    padding: 40px 0 96px 0;

    .reason-item {
      width: 282px;
      height: 270px;
      padding: 32px 24px;
      border: 1px solid var(--border);
      background-color: var(--theme-bg-opacity);

      i {
        font-size: 28px;
        color: var(--theme-primary);
      }

      .reason-item__title {
        margin-top: 24px;
        font-size: 26px;
        font-weight: bold;
        @include one-line-ellipsis();
      }

      .reason-item__content {
        display: flow-root;
        margin-top: 14px;
        font-size: 16px;
        line-height: 24px;
        font-weight: 300;
        color: var(--text-lighter);
        @include line-ellipsis(4);
      }
    }
  }
}
</style>
